import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocRestrictSensitiveOrSecret(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.42 99.693c-6.307 0-11.42-5.113-11.42-11.42h57.102c0 6.307 5.113 11.42 11.42 11.42H22.42Z"
        fill="#E2E8F0"
      />
      <path
        d="M79.523 99.693c6.307 0 11.42-5.113 11.42-11.42V19.75H33.841v68.523c0 6.307-5.113 11.42-11.42 11.42h57.102Z"
        fill="#F1F5F9"
      />
      <path
        d="M34.64 88.272c0 6.75-5.47 12.221-12.22 12.221a.8.8 0 0 1 0-1.6c5.866 0 10.621-4.755 10.621-10.62a.8.8 0 0 1 1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M82.378 81.763a.8.8 0 0 1 0 1.6H42.406a.8.8 0 1 1 0-1.6h39.972Zm0-5.71a.8.8 0 1 1 0 1.6H42.406a.8.8 0 0 1 0-1.6h39.972Zm0-5.711a.8.8 0 0 1 0 1.6H42.406a.8.8 0 0 1 0-1.6h39.972Zm0-5.71a.8.8 0 0 1 0 1.6H42.406a.8.8 0 0 1 0-1.6h39.972Zm-14.752-5.71a.8.8 0 1 1 0 1.6h-25.22a.8.8 0 1 1 0-1.6h25.22Zm0-5.71a.8.8 0 1 1 0 1.6h-25.22a.8.8 0 0 1 0-1.6h25.22Zm0-5.711a.801.801 0 0 1 0 1.6h-25.22a.8.8 0 0 1 0-1.6h25.22Zm0-5.71a.8.8 0 0 1 0 1.6h-25.22a.8.8 0 1 1 0-1.6h25.22Zm0-5.71a.8.8 0 1 1 0 1.6h-25.22a.8.8 0 1 1 0-1.6h25.22Z"
        fill="#B3C0D0"
      />
      <path
        d="M90.5 16C84.708 16 80 20.956 80 27.085v9.26c0 .89.682 1.6 1.509 1.6.826 0 1.508-.71 1.508-1.6v-9.26c0-4.349 3.344-7.886 7.483-7.886 4.14 0 7.483 3.537 7.483 7.886v9.316c0 .864.644 1.563 1.446 1.598.85.037 1.571-.681 1.571-1.598v-9.316C101 20.956 96.292 16 90.5 16Z"
        fill="#007A5F"
      />
      <path
        d="M100.5 27.085c0-5.878-4.51-10.585-10-10.585-5.491 0-10 4.707-10 10.585v9.26c0 .64.483 1.1 1.009 1.1.526 0 1.009-.46 1.009-1.1v-9.26c0-4.6 3.542-8.387 7.982-8.387s7.982 3.788 7.982 8.387v9.316c0 .62.457 1.076.97 1.098.538.024 1.048-.44 1.048-1.098v-9.316Zm1 9.316c0 1.175-.933 2.148-2.093 2.097-1.092-.048-1.924-.988-1.925-2.097v-9.316c0-4.098-3.144-7.387-6.982-7.387s-6.982 3.289-6.982 7.387v9.26c0 1.142-.882 2.1-2.01 2.1-1.126 0-2.008-.958-2.008-2.1v-9.26c0-6.38 4.907-11.585 11-11.585s11 5.206 11 11.585v9.316Z"
        fill="#007A5F"
      />
      <path
        d="M74 36a3 3 0 0 1 3-3h28a3 3 0 0 1 3 3v21a3 3 0 0 1-3 3H77a3 3 0 0 1-3-3V36Z"
        fill="#78B441"
      />
      <path
        d="M92.058 46.493c-.024-.115.048-.227.166-.275 1.046-.426 1.776-1.38 1.776-2.49C94 42.22 92.657 41 91 41s-3 1.221-3 2.727c0 1.11.73 2.066 1.777 2.492.117.047.19.16.165.274l-1.226 5.944c-.06.292.187.563.514.563h3.54c.327 0 .575-.27.514-.563l-1.226-5.944Z"
        fill="#00664F"
      />
      <path
        d="M92.976 43.727c0-.85-.791-1.703-1.976-1.703s-1.976.853-1.976 1.703c0 .635.42 1.25 1.14 1.543h-.002c.47.19.93.73.783 1.433l-1.088 5.273h2.286L91.055 46.7c-.144-.7.31-1.239.782-1.43l.132-.06c.637-.31 1.007-.887 1.007-1.483Zm2.048 0c0 1.357-.761 2.497-1.841 3.15l1.104 5.351c.217 1.047-.666 1.796-1.518 1.796h-3.538c-.854 0-1.732-.751-1.518-1.794l1.103-5.353c-1.08-.653-1.84-1.794-1.84-3.15 0-2.161 1.895-3.751 4.024-3.751 2.128 0 4.024 1.59 4.024 3.752Z"
        fill="#00664F"
      />
      <path
        d="M73.2 51V37a4.8 4.8 0 0 1 4.8-4.8h26a.8.8 0 1 1 0 1.6H78a3.2 3.2 0 0 0-3.2 3.2v14a.8.8 0 1 1-1.6 0Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocRestrictSensitiveOrSecret)
